import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppConfigService } from '../../services/app-config.service';
import { HeroPuzzleComponent } from '../shared/hero-puzzle/hero-puzzle.component';

@Component({
  selector: 'app-hero-home',
  standalone: true,
  imports: [RouterLink, HeroPuzzleComponent],
  templateUrl: './hero-home.component.html',
  styleUrl: './hero-home.component.scss',
})
export class HeroHomeComponent {
  readonly app = inject(AppConfigService);
}
